import { render } from "./PhysicalBranchList.vue?vue&type=template&id=56012148&scoped=true"
import script from "./PhysicalBranchList.vue?vue&type=script&lang=js"
export * from "./PhysicalBranchList.vue?vue&type=script&lang=js"

import "./PhysicalBranchList.vue?vue&type=style&index=0&id=56012148&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56012148"]])

export default __exports__